module.exports = __webpack_public_path__ + "static/chunks/src/page-home/part-benefits/assets/image-money-back.8d5d7bad8daa4733f73fdc18774f5f27.webp";